module.exports = __webpack_public_path__ + "fonts/NanumSquare.457d0053.woff2";